import { SentryRoute as Route } from '@occc-app/App/sentry';

import { routeCreator } from './retailer-connect.utils';
import RetailerNetworkListPage, {
  RetailerNetworkListPageGuard,
} from './retailer-network-list-page';
import RetailerNetworkCreatePage, {
  RetailerNetworkCreatePageGuard,
} from './retailer-network-create-page';
import RetailerNetworkUpdatePage, {
  RetailerNetworkUpdatePageGuard,
} from './retailer-network-update-page';
import RetailerNetworkDetailsPage, {
  RetailerNetworkDetailsPageGuard,
} from './retailer-network-details-page';
import { RetailerNetworkLocationDetailsPageGuard } from './retailer-network-location-details-page';
import { RetailerNetworkLocationUpdatePageGuard } from './retailer-network-location-update-page';
import { RetailerNetworkLocationGroupDetailsPageGuard } from './retailer-network-location-group-details-page';
import { RetailerNetworkLocationDetailsVersionSwitch } from './retailer-network-location-details-version-switch.component';
import { RetailerNetworkLocationUpdateVersionSwitch } from './retailer-network-location-update-version-switch.component';
import { RetailerNetworkLocationGroupDetailsVersionSwitch } from './retailer-network-location-group-details-version-switch.component';
import RetailerNetworkUserDetailsPage, {
  RetailerNetworkUserDetailsPageGuard,
} from './retailer-network-user-details-page';
import RetailerNetworkOverviewPage, {
  RetailerNetworkOverviewPageGuard,
} from './retailer-network-overview-page';
import RetailerNetworkPerformancePage, {
  RetailerNetworkPerformancePageGuard,
} from './retailer-network-performance-page';
import { RetailerNetworkMyStoresPageGuard } from './retailer-network-my-stores-page';
import { RetailerNetworkMyStoresVersionSwitch } from './retailer-network-my-stores-version-switch.component';
import RetailerNetworkMyStoresGroupPage, {
  RetailerNetworkMyStoresGroupPageGuard,
} from './retailer-network-my-stores-group-page';
import RetailerNetworkMyStoresStorePage, {
  RetailerNetworkMyStoresStorePageGuard,
} from './retailer-network-my-stores-store-page';
import RetailerNetworkTobaccoPage, {
  RetailerNetworkTobaccoPageGuard,
} from './retailer-network-tobacco-page';
import RetailerNetworkTobaccoScanDataPage, {
  RetailerNetworkTobaccoScanDataPageGuard,
} from './retailer-network-tobacco-scan-data-page';
import RetailerNetworkBasePage from './retailer-network-base-page';
import RetailerNetworkTobaccoPerformanceDetailsPage, {
  RetailerNetworkTobaccoPerformanceDetailsPageGuard,
} from './retailer-network-tobacco-performance-details-page';
import { RetailerNetworkTobaccoPerformanceGuard } from './guards/retailer-network-tobacco-performance.guard';
import { RetailerNetworkContextProvider } from './retailer-network-context/retailer-network-context';

export const retailerConnectRoutes = (
  <>
    <Route path={routeCreator.base()} element={<RetailerNetworkBasePage />} />
    <Route
      path={`${routeCreator.configuration}/*`}
      element={
        <RetailerNetworkCreatePageGuard>
          <RetailerNetworkCreatePage />
        </RetailerNetworkCreatePageGuard>
      }
    />
    <Route
      path={routeCreator.list()}
      element={
        <RetailerNetworkListPageGuard>
          <RetailerNetworkListPage />
        </RetailerNetworkListPageGuard>
      }
    />
    <Route
      path={routeCreator.overviewDefault()}
      element={
        <RetailerNetworkListPageGuard>
          <RetailerNetworkListPage
            redirectTo='overview'
            pageSubtitle='Select a network to view the overview dashboard'
          />
        </RetailerNetworkListPageGuard>
      }
    />
    <Route
      path={routeCreator.performanceDefault()}
      element={
        <RetailerNetworkListPageGuard>
          <RetailerNetworkListPage
            redirectTo='performance'
            pageSubtitle='Select a network to view the performance'
          />
        </RetailerNetworkListPageGuard>
      }
    />
    <Route
      path={routeCreator.myStoresDefault()}
      element={
        <RetailerNetworkListPageGuard>
          <RetailerNetworkListPage
            redirectTo='myStores'
            pageSubtitle='Select a network to view the stores'
          />
        </RetailerNetworkListPageGuard>
      }
    />
    <Route
      path={routeCreator.tobaccoDefault()}
      element={
        <RetailerNetworkTobaccoPerformanceGuard>
          <RetailerNetworkListPageGuard>
            <RetailerNetworkListPage
              redirectTo='tobacco'
              pageSubtitle='Select a network to view the tobacco scan data'
            />
          </RetailerNetworkListPageGuard>
        </RetailerNetworkTobaccoPerformanceGuard>
      }
    />
    <Route element={<RetailerNetworkContextProvider />}>
      <Route
        path={`${routeCreator.configurationUpdate(':networkId')}/*`}
        element={
          <RetailerNetworkUpdatePageGuard>
            <RetailerNetworkUpdatePage />
          </RetailerNetworkUpdatePageGuard>
        }
      />
      <Route
        path={routeCreator.details(':networkId')}
        element={
          <RetailerNetworkDetailsPageGuard>
            <RetailerNetworkDetailsPage />
          </RetailerNetworkDetailsPageGuard>
        }
      />
      <Route
        path={routeCreator.locationDetails(':networkId', ':locationId')}
        element={
          <RetailerNetworkLocationDetailsPageGuard>
            <RetailerNetworkLocationDetailsVersionSwitch />
          </RetailerNetworkLocationDetailsPageGuard>
        }
      />
      <Route
        path={routeCreator.locationUpdate(':networkId', ':locationId')}
        element={
          <RetailerNetworkLocationUpdatePageGuard>
            <RetailerNetworkLocationUpdateVersionSwitch />
          </RetailerNetworkLocationUpdatePageGuard>
        }
      />
      <Route
        path={routeCreator.locationGroupDetails(':networkId', ':locationGroupId')}
        element={
          <RetailerNetworkLocationGroupDetailsPageGuard>
            <RetailerNetworkLocationGroupDetailsVersionSwitch />
          </RetailerNetworkLocationGroupDetailsPageGuard>
        }
      />
      <Route
        path={routeCreator.userDetails(':networkId', ':userId')}
        element={
          <RetailerNetworkUserDetailsPageGuard>
            <RetailerNetworkUserDetailsPage />
          </RetailerNetworkUserDetailsPageGuard>
        }
      />
      <Route
        path={routeCreator.overview(':networkId')}
        element={
          <RetailerNetworkOverviewPageGuard>
            <RetailerNetworkOverviewPage />
          </RetailerNetworkOverviewPageGuard>
        }
      />
      <Route
        path={`${routeCreator.performance(':networkId')}/*`}
        element={
          <RetailerNetworkPerformancePageGuard>
            <RetailerNetworkPerformancePage />
          </RetailerNetworkPerformancePageGuard>
        }
      />
      <Route
        path={routeCreator.myStores(':networkId')}
        element={
          <RetailerNetworkMyStoresPageGuard>
            <RetailerNetworkMyStoresVersionSwitch />
          </RetailerNetworkMyStoresPageGuard>
        }
      />
      <Route
        path={routeCreator.myStoresGroup(':networkId', ':groupId')}
        element={
          <RetailerNetworkMyStoresGroupPageGuard>
            <RetailerNetworkMyStoresGroupPage />
          </RetailerNetworkMyStoresGroupPageGuard>
        }
      />
      <Route
        path={routeCreator.myStoresStore(':networkId', ':storeId')}
        element={
          <RetailerNetworkMyStoresStorePageGuard>
            <RetailerNetworkMyStoresStorePage />
          </RetailerNetworkMyStoresStorePageGuard>
        }
      />
      <Route
        path={routeCreator.tobacco(':networkId')}
        element={
          <RetailerNetworkTobaccoPageGuard>
            <RetailerNetworkTobaccoPage />
          </RetailerNetworkTobaccoPageGuard>
        }
      />
      <Route
        path={routeCreator.tobaccoScanData(':networkId')}
        element={
          <RetailerNetworkTobaccoScanDataPageGuard>
            <RetailerNetworkTobaccoScanDataPage />
          </RetailerNetworkTobaccoScanDataPageGuard>
        }
      />
      <Route
        path={routeCreator.tobaccoPerformanceDetails(':networkId')}
        element={
          <RetailerNetworkTobaccoPerformanceDetailsPageGuard>
            <RetailerNetworkTobaccoPerformanceDetailsPage />
          </RetailerNetworkTobaccoPerformanceDetailsPageGuard>
        }
      />
    </Route>
  </>
);
